import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableUseStyle = makeStyles(
  createStyles({

    //テーブルヘッダセル
    headerCell: {
      padding: '2px',
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      minWidth: '80px',
      borderCollapse: `collapse`,
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '1px',
      height: '40px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '1px',
      height: '40px',
    },
    bodyRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: '#7fffd4',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },
    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      border: 'none',
      backgroundColor: 'transparent',
      textAlign: "center",
    },

    logTimeField: {
      paddingLeft: "2px",
      width: '24px',
    },
  })
);

export const IoTBoxSettingStyle = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 324px)',
      //overflowX: 'scroll',
    },
    flexBox: {
      display: "flex",
    },
    tableDialgContainer: {
      maxHeight: 'calc(100vh - 276px)',
    },
    paper: {
      background: '#FFFFEE',
    },
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);
